// src/components/Logo.js
import React from "react";

function Logo({ w, link }) {
  const width = w || "100px";
  const logoUrl = `${process.env.PUBLIC_URL}/images/logo.png`;

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <img
        src={logoUrl}
        alt="Logo"
        style={{ width: width }}
        className="mx-auto mb-4" // Center the logo and add margin
      />
    </a>
  );
}

export default Logo;
